module.exports = __webpack_public_path__ + "img/default-project-image.4d184756.webp";